import type { AssetTypesListTableRowActionsProps } from "./asset-types-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import AssetTypesListTableRowActions from "./asset-types-list-table-row-actions.component";

const AssetTypesListTableRowActionsWrapper = (
  props: AssetTypesListTableRowActionsProps
) => {
  return (
    <ListTableRowActions>
      <AssetTypesListTableRowActions {...props} />
    </ListTableRowActions>
  );
};

export default AssetTypesListTableRowActionsWrapper;
